import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import adminRoutes from "routes/admin-routes";
import PageHeader from "./sections/PageHeader";
import ContainerCard from "components/ContainerCard";
import Container from "@mui/material/Container";
import { AgentInstructionsProvider } from "./contexts/AgentInstructionsContext";
import AgentInfo from "./sections/AgentInfo";
import AgentInstructionsForm from "./components/AgentInstructionsForm";
import Breadcrumbs from "examples/Breadcrumbs";

function AgentInstructions() {
  return (
    <>
      <DefaultNavbar routes={adminRoutes} />
      <PageHeader />

      <ContainerCard>
        <Container>
          <Breadcrumbs
            routes={[
              { label: "Admin", route: "/admin" },
              { label: "Chatbot Logica", route: "/admin/agents" },
              { label: "Agent Instructies" },
            ]}
          />
          <AgentInstructionsProvider>
            <AgentInfo />
            <AgentInstructionsForm />
          </AgentInstructionsProvider>
        </Container>
      </ContainerCard>
    </>
  );
}

export default AgentInstructions;
